// This file is generated by pnpm icons:generate. Do not edit.

import {Tote as CanonicalTote} from './brands/Tote'

/** @deprecated Import Tote from `#/components/icons/brands/Tote` instead. */
export const Tote = CanonicalTote
